import React from 'react';

export default function TermsConditions() {
  return (
    <div className="pt-16">
      {/* Header Section */}
      <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h1 className="text-5xl font-extrabold mb-4">Terms & Conditions</h1>
          <p className="text-blue-100 text-lg">Last updated: January 30, 2025</p>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-10 py-16">
        <div className="prose prose-lg max-w-none leading-relaxed">
          <p className="text-gray-700 text-lg">
            These Terms and Conditions govern your use of <strong>UCX</strong>'s website and services. By accessing or using our services, you agree to be bound by these terms.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8">Acceptance of Terms</h2>
          <p>
            By accessing our website or using our services, you acknowledge that you have read, understood, and agree to be bound by these terms.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Service Description</h2>
          <p>
            UCX provides a range of IT management and cybersecurity solutions, including:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Managed IT Services</li>
            <li>Co-Managed IT Solutions</li>
            <li>Cybersecurity Services</li>
            <li>Professional Services</li>
            <li>Consulting Services</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">User Responsibilities</h2>
          <p>
            As a user, you agree to:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide accurate and up-to-date information.</li>
            <li>Maintain the confidentiality and security of your account credentials.</li>
            <li>Comply with all applicable laws and regulations.</li>
            <li>Use our services for lawful and intended purposes only.</li>
            <li>Report any unauthorized access or security breaches immediately.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">Intellectual Property</h2>
          <p>
            All content, features, and functionality provided by UCX, including text, graphics, logos, images, software, and other materials, are owned by UCX and are protected by copyright, trademark, and other intellectual property laws.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Limitation of Liability</h2>
          <p>
            UCX shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your use of our services, including but not limited to loss of data, revenue, or business opportunities.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Modification of Terms</h2>
          <p>
            We reserve the right to update or modify these Terms & Conditions at any time. Changes will be communicated through our website or via email. Continued use of our services after modifications constitutes acceptance of the updated terms.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Governing Law</h2>
          <p>
            These Terms & Conditions are governed by and construed in accordance with the laws of the State of Texas, without regard to its conflict of law principles.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Contact Information</h2>
          <p>
            If you have any questions or concerns regarding these Terms & Conditions, please contact us:
          </p>
          <ul className="list-none space-y-2">
            <li><strong>Email:</strong> <a href="mailto:legal@ucx.co" className="text-blue-600 hover:underline">legal@ucx.co</a></li>
            <li><strong>Phone:</strong> <a href="tel:+18442193935" className="text-blue-600 hover:underline">844-219-3935</a></li>
            <li><strong>Address:</strong> 1348 Hwy 287, Suite 300, Waxahachie, TX 75165</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
